export const COOKIE_NAMES = {
  ACCESS_TOKEN: 'auth_access_token',
  ID_TOKEN: 'auth_id_token',
  REFRESH_TOKEN: 'auth_refresh_token',
  EXPIRES_AT: 'auth_expires_at',
};

export const impersonatedUserIdCookieKey = 'impersonatedUserId';

export enum UserRoles {
  ADMINISTRATOR = 'administrator',
  PROCTOR = 'proctor',
  STUDENT = 'student',
  TEACHER = 'teacher',
  PARENT = 'parent',
  AIDE = 'aide',
  SYSTEM_ADMINISTRATOR = 'system_administrator',
}

/**
 * Roles that have elevated access to view/manage other users' data.
 * Includes administrators, aides, and teachers (guides).
 */
export const ELEVATED_ROLES = [
  UserRoles.ADMINISTRATOR,
  UserRoles.AIDE,
  UserRoles.TEACHER,
];
